// extracted by mini-css-extract-plugin
export default {"deleteIcon":"deleteIcon__uuFkx"};